<!-- version 2021/05/20 -->
<template>
<a :href="link" class="content-home-nav-item__link">
  <div class="content-home-nav-item__link-inner">
    <img :src="imagePath" alt="Flower Photo" class="content-home-nav-item__link-inner-img">
    <app-title-text :text="title" class="content-home-nav-item__link-inner-title"></app-title-text>
  </div>
</a>
</template>

<script>
export default {
  props: {
    imagePath: String,
    title: String,
    link: String
  }
}
</script>
